import { has } from "shared/utils";
import { AuditSummaryFlag } from "./AuditSummaryFlag";
import { FullApplicant, Verification } from "../types";

interface EvictionReportContentProps {
  verification: Verification;
  applicant: FullApplicant;
  hasAuditFlagEnabled: boolean;
}

export const EvictionReportContent = ({
  verification,
  applicant,
  hasAuditFlagEnabled
}: EvictionReportContentProps) => {
  if (has(verification.summary?.events_reported))
    return <span>{verification.summary.events_reported}</span>;

  if (hasAuditFlagEnabled)
    return (
      <AuditSummaryFlag audit_summary_flags={applicant.audit_summary_flags} />
    );

  return <span>-</span>;
};
